import { useState, useEffect } from 'react'

export function useFingerPrint() {
  const [fingerPrintResult, setFingerPrintResult] = useState('loading')

  useEffect(() => {
    const interval = setInterval(() => {
      if (typeof window.fingerPrintResult !== 'undefined') {
        setFingerPrintResult(window.fingerPrintResult)
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return fingerPrintResult
}
